import { Alert } from '@mui/material';

interface AlertProps {
  status: 'error' | 'idle' | 'loading' | 'success';
  message?: string;
  errorMessage?: string;
  style?: any;
}

export default function CustomAlert(props: AlertProps) {
  const { status, message, errorMessage, style } = props;
  return (
    <>
      {(message || errorMessage) && status !== 'loading' ? (
        <Alert
          sx={[{ width: '100%' }, style]}
          severity={status === 'error' ? status : 'success'}
        >
          {status === 'error' && errorMessage ? errorMessage : message}
        </Alert>
      ) : null}
    </>
  );
}
